import React from "react"
import Button from "../../Components/Button"
import SlideOver from "../../Components/SlideOver"
import CreateUser from "./CreateUser"
import PreviewUser from "./PreviewUser"
import EditUser from "./EditUser"
import ChangePassword from "./ChangePassword"
import ManageImages from "./ManageImages"

const UserListSlideOvers = ({
    openCreateUser,
    createTitle = "Add User",
    createSubtitle,
    onCloseCreate,
    onCreated,
    createUserActions,
    onCreateActionsReady,
    selectedDetailUser,
    onCloseDetail,
    onEditFromDetail,
    selectedEditUser,
    onCloseEdit,
    onEditSaved,
    editUserActions,
    onEditActionsReady,
    selectedPasswordUser,
    onClosePassword,
    selectedManageImagesUser,
    onCloseManageImages,
    onManageImagesSaved,
}) => {
    const [passwordCloseLocked, setPasswordCloseLocked] = React.useState(false)

    React.useEffect(() => {
        if (!selectedPasswordUser) setPasswordCloseLocked(false)
    }, [selectedPasswordUser])

    return (
        <>
            <SlideOver
                show={openCreateUser}
                title={createTitle}
                subtitle={createSubtitle}
                onClose={onCloseCreate}
                actions={createUserActions && (
                    <>
                        <Button injectClass={"rounded-full px-5"} type="secondary" onClick={createUserActions.onCancel}>{createUserActions.cancelLabel || 'Cancel'}</Button>
                        <Button injectClass={"rounded-full px-5"} type="primary" onClick={createUserActions.onSave}>{createUserActions.saveLabel || 'Save'}</Button>
                    </>
                )}
            >
                <CreateUser
                    compactMode
                    onCancel={onCloseCreate}
                    onActionsReady={onCreateActionsReady}
                    onCreated={onCreated}
                />
            </SlideOver>

            <SlideOver
                show={Boolean(selectedDetailUser)}
                title="User Details"
                subtitle={selectedDetailUser ? `${selectedDetailUser.firstName || ""} ${selectedDetailUser.surname || ""} - ${selectedDetailUser.refId || ""}` : "Profile details"}
                onClose={onCloseDetail}
                noPad
            >
                {selectedDetailUser && (
                    <PreviewUser
                        key={selectedDetailUser._id}
                        embedded
                        onClose={onCloseDetail}
                        onEdit={onEditFromDetail ? () => onEditFromDetail(selectedDetailUser) : undefined}
                        match={{ params: { id: selectedDetailUser._id } }}
                    />
                )}
            </SlideOver>

            <SlideOver
                show={Boolean(selectedEditUser)}
                title="Edit User"
                subtitle={selectedEditUser ? `Update ${selectedEditUser.firstName || ""} ${selectedEditUser.surname || ""} - ${selectedEditUser.refId || ""}` : "Edit profile details"}
                onClose={onCloseEdit}
                actions={editUserActions?.onCancel && (
                    <>
                        <Button injectClass={"rounded-full px-5"} type="secondary" onClick={editUserActions.onCancel}>{editUserActions.cancelLabel || 'Cancel'}</Button>
                        <Button injectClass={"rounded-full px-5"} type="primary" disabled={editUserActions.submitDisabled} onClick={editUserActions.onSave}>
                            {editUserActions.submitDisabled ? (editUserActions.savingLabel || 'Saving…') : (editUserActions.saveLabel || 'Save')}
                        </Button>
                    </>
                )}
            >
                {selectedEditUser && (
                    <EditUser
                        key={selectedEditUser._id}
                        embedded
                        compactMode
                        onActionsReady={onEditActionsReady}
                        onClose={onCloseEdit}
                        onSaved={onEditSaved}
                        match={{ params: { id: selectedEditUser._id } }}
                    />
                )}
            </SlideOver>

            <SlideOver
                show={Boolean(selectedPasswordUser)}
                title="Change Password"
                subtitle={selectedPasswordUser ? `Update access for ${selectedPasswordUser.firstName || ""} ${selectedPasswordUser.surname || ""}` : "Update member password"}
                onClose={onClosePassword}
                disableClose={passwordCloseLocked}
            >
                {selectedPasswordUser && (
                    <ChangePassword
                        embedded
                        defaultMobile={selectedPasswordUser?.contactInformation?.mobileNumber}
                        defaultUserId={selectedPasswordUser?._id}
                        defaultUserName={`${selectedPasswordUser?.firstName || ""} ${selectedPasswordUser?.surname || ""}`.trim()}
                        onClose={onClosePassword}
                        onCloseLockChange={setPasswordCloseLocked}
                    />
                )}
            </SlideOver>

            <SlideOver
                show={Boolean(selectedManageImagesUser)}
                title="Manage Images"
                subtitle={selectedManageImagesUser ? `Photos for ${selectedManageImagesUser.firstName || ""} ${selectedManageImagesUser.surname || ""} - ${selectedManageImagesUser.refId || ""}` : "Upload & manage profile photos"}
                onClose={onCloseManageImages}
            >
                {selectedManageImagesUser && (
                    <ManageImages
                        key={selectedManageImagesUser._id}
                        userId={selectedManageImagesUser._id}
                        onClose={onCloseManageImages}
                        onSaved={onManageImagesSaved}
                    />
                )}
            </SlideOver>
        </>
    )
}

export default UserListSlideOvers
